import React from 'react';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useTranslation } from 'react-i18next';
import { LaneRateView } from './LaneRateView';

export function LaneRatesViewPage() {
  const { t } = useTranslation();

  const breadcrumbs = {
    pages: [
      {
        name: t('LANE_RATES'),
        href: '/lane-rates',
        current: false,
      },
      {
        name: 'View Lane Rate',
        current: true,
      },
    ],
  };

  return (
    <main className="py-4">
      <LayoutWithSidebar title={t('LANE_RATES')} breadcrumbs={breadcrumbs}>
        <LaneRateView />
      </LayoutWithSidebar>
    </main>
  );
}
